import { defineStore } from 'pinia'

export const useLoaderStore = defineStore('loader', {
  state: () => ({
    active: false
  }),

  actions: {
    updateLoader(newState) {
      this.active = newState
    }
  }
}) 